import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'prompt', 'Prompt', [["path",{"d":"M5 7l5 5l-5 5"}],["path",{"d":"M13 17l6 0"}]]);